module.exports = __webpack_public_path__ + "static/media/drmias_1video.25e39034.m4v";